export default "__VITE_ASSET__201e8c0d__"